import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-settingsparkinghome',
    templateUrl: './settingsparkinghome.component.html',
    styleUrls: ['./settingsparkinghome.component.scss'],
    standalone: false
})
export class SettingsparkinghomeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
